'use client';
import { Icon, Link } from '@theme/components';
import clsx from 'clsx';
import { HeaderBandMenuType } from './band';

import { useSession } from 'next-auth/react';

export const HeaderBandLink = ({
  link,
  className
}: {
  link: HeaderBandMenuType;
  className?: string;
}) => {
  const { data: session } = useSession();

  return (
    <Link
      href={
        session && link.value.loggedin_url
          ? link.value.loggedin_url
          : link.value.url
      }
      target={link.value.open_in_new_tab === 'yes' ? '_blank' : '_self'}
      className={clsx([
        className,
        'flex items-center',
        link.value.show_in === 'desktop' && 'hidden md:inline-flex',
        link.value.show_in === 'mobile' && 'inline-flex md:hidden'
      ])}
    >
      {link.value.text}
      {link.value.icon && (
        <Icon className="ml-1" name={link.value.icon} size={24} />
      )}
    </Link>
  );
};
